export const useTitle = ({title}) => {
  return (
    document.title = `TIP Method | ${title}`
  )
}
